import React from "react";

export const NotFoundPage = () => <div>Page not found</div>;
